export default __webpack_public_path__ + "static/anilPokhriyal-2acabbaafe415c7a32c572cba320d305.jpg";